import SplashScreenComponent from './SplashScreen.component';

export * from './SplashScreen.component';
export default SplashScreenComponent;